import React from "react";
import { map } from "lodash";
import styled from "styled-components";
import { shorten } from "@backpacker/number";
import { FontWeight } from "@glossy";
import { Locale } from "@linkfluence/models/locale";
import { Metric } from "@linkfluence/models/metric";
import Rating from "@ui-kit/rating";
import { tr } from "@radarly/i18n";
import { Post, PostLensFactory } from "@radarly/models/posts";
import TooltipWrapper from "./tooltip";

interface IProps {
  post: Post;
  locale: Locale;
}

const MetricScore = styled.div`
  font-weight: ${FontWeight.Bold};
  margin-bottom: 24px;
`;

const formatMetricScore = (locale: Locale, metric: Metric, score: number) => {
  if (metric === Metric.Rating) return <Rating locale={locale} value={score} />;
  return shorten(locale, score);
};

const RadarlyPostMetricsScores = ({ post, locale }: IProps) => {
  const postMetrics = PostLensFactory.create(post).getMetrics();
  return (
    <>
      {map(postMetrics, (pm, key) => (
        <TooltipWrapper key={key} metric={key} value={pm} locale={locale}>
          <div>
            <div>{tr(locale, `POST::METRIC::${key}`)}</div>
            <MetricScore>
              {formatMetricScore(locale, key as Metric, pm)}
            </MetricScore>
          </div>
        </TooltipWrapper>
      ))}
    </>
  );
};

export default RadarlyPostMetricsScores;
